import { forwardRef } from 'react';

import { MenuActionButton } from '@/components/FilterManager/components/ActionButton';
import { getButtonLabel } from '@/components/FilterManager/SortAndFilter/helpers';

import { SortMenuButtonProps } from './types';

const SortMenuButton = forwardRef<HTMLButtonElement, SortMenuButtonProps>((props, ref) => {
  const { defaultPlaceholder, selectedItems, ...rest } = props;
  const selectedItemsLabels = selectedItems.map((item) => item.label);

  return (
    <MenuActionButton ref={ref} id="sort" isSelected={!!selectedItemsLabels.length} {...rest}>
      {getButtonLabel(selectedItemsLabels, defaultPlaceholder)}
    </MenuActionButton>
  );
});

export default SortMenuButton;
